import { OrganizationSearchCard } from '@platform/client/schemas';
import { Icon } from '@platform/components';

type OrganizationCardProps = {
  organization: OrganizationSearchCard;
};

export const OrganizationCard = (props: OrganizationCardProps) => {
  const { name, image, id, businessType, industries, location } = props.organization;

  const formattedIndustries = industries?.slice(0, 2).join(' and ');
  return (
    <a
      className='min-w-[300px] h-[450px] flex flex-col bg-white shadow-md rounded-md cursor-pointer'
      href={`/platform/directory/organizations/${id}`}
      target='_blank'
    >
      {image ?
        <img src={image ?? ''} className='w-full h-1/2 rounded-md object-contain' />
        : <div className='w-full h-1/2 rounded-md bg-gray-100' />}
      <div className='w-full h-1/2 flex flex-col justify-between border-t border-gray-100 gap-3 p-6'>
        <div>
          <div className='font-semibold text-xl/[24px] text-gray-500 pb-4'>{name}</div>
          {formattedIndustries && (
            <div className='text-sm'>
              A {businessType} organization with in {formattedIndustries}
            </div>
          )}
        </div>
        <div>
          <div className='flex flex-row gap-3 items-center'>
            <div className='flex flex-col justify-center items-center gap-1 text-gray-400'>
              <Icon type='marker-pin-01' size='19' />
              <div className='text-sm'>{location}</div>
            </div>
            <div className='flex flex-col justify-center items-center gap-1 text-gray-400'>
              <Icon type='monitor-01' size='19' />
              <div className='text-sm'>Remote</div>
            </div>
            <div className='flex flex-col justify-center items-center gap-1 text-gray-400'>
              <Icon type='target-01' size='19' />
              <div className='text-sm'>SDG</div>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};
